const INITIAL_STATE = {
  errors: {},
  technicianList: {}
}

const fieldTechnician = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_TECHNICIAN_LIST':
    return { ...state, ...INITIAL_STATE, technicianList: action.data }
  case 'GET_TECHNICIAN_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_FIELD_TECHNICIAN_FILTER':
    return { ...state, ...INITIAL_STATE, technicianList: action.data }
  case 'GET_FIELD_TECHNICIAN_FILTER_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default fieldTechnician;
